import React from "react";

function Facebook() {
  return (
    <div>
      <img
        width="35px"
        height="35px"
        alt="Facebook"
        src="https://static.xx.fbcdn.net/rsrc.php/v3/yI/r/k0tRiO8UGxF.png"
      />
    </div>
  );
}

export default Facebook;
